import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { CoverageFilterInput } from '../gql/graphql';
import { toPagination } from './utils';

export const GET_ULAE_PAYMENT_COVERAGES = graphql(`
  query getUlaePaymentCoverages(
    $filters: CoverageFilterInput!
    $pagination: PaginationRequest
  ) {
    ulaePaymentCoverages(filters: $filters, pagination: $pagination) {
      pageInfo {
        totalResults
        pageNumber
        pageSize
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          name
          order
        }
      }
    }
  }
`);

export interface IUseUlaePaymentCoveragesQueryArgs {
  pageNumber?: number;
  pageSize?: number;
  filters: CoverageFilterInput;
  skip?: boolean;
}

export function useUlaePaymentCoveragesQuery({
  pageNumber,
  pageSize,
  filters,
  skip = false,
}: IUseUlaePaymentCoveragesQueryArgs) {
  const { loading, data, error, refetch } = useQuery(
    GET_ULAE_PAYMENT_COVERAGES,
    {
      variables: {
        filters,
        pagination: toPagination(pageNumber, pageSize),
      },
      fetchPolicy: 'no-cache',
      skip,
    }
  );

  return {
    loading,
    error,
    data,
    refetch,
  };
}
